import React from "react";
import { Alert } from "react-bootstrap";
import Images from "../../../assets/images/index";
import { useLocation } from "react-router-dom";

class ErrorBoundary extends React.Component {

    constructor(props) {
        super(props);
        this.state = { error: null, errorInfo: null };
        // this.currentUrl=""
        
    }

    // componentDidMount(){
    //     this.currentUrl=window.location.href
    // }
      

    
    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo?.componentStack
        })
    }

    
    render() {
        
        if (this.state.errorInfo ) {
            return (
                <div className="main_wrapper">
                    <div className="breadcrumbs">

                    </div>
                    <section className="videoLayer_wrapper section_side_padding">
                        <div className="row">
                            <div className="col-lg-8 col-md-7 col-sm-12">

                                {/* <Alert variant="danger">
                                    <Alert.Heading>{this.state.error?.message}</Alert.Heading>
                                    <p>
                                        {this.state.errorInfo}
                                    </p>
                                </Alert> */}
                                <div className="no_data_found_wrapper something_went_wrong text-center mt-4">
                                    <img src={Images.NoDataImg} alt="No Data" className="img-fluid" />
                                    <div className="no_data_text">
                                        <h4>Oops, an error has been occured</h4>
                                        <p>{this.state.error?.message}</p>
                                    </div>
                                    <div className="retry_btn">
                                        <button type="button" onClick={() => { window.reload() }} className="btn btn_theme">Retry Now</button>
                                    </div>
                                </div>
                            </div>

                        </div></section></div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary